import React from "react";
import { Link } from "react-router-dom";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-100 to-purple-200 text-gray-800">
      {/* Hero */}
      <section className="text-center py-20 px-6">
        <h1 className="text-5xl font-extrabold text-pink-600 drop-shadow mb-4">
          Welcome to Festigram 🎉
        </h1>
        <p className="text-lg max-w-xl mx-auto mb-8">
          Create beautiful, interactive event pages where guests can leave
          messages, share memories, and celebrate together.
        </p>
        <Link
          to="/admin/setup"
          className="inline-block bg-pink-500 hover:bg-pink-600 text-white font-semibold px-6 py-3 rounded-full text-lg shadow-lg"
        >
          Get Started
        </Link>
      </section>

      {/* How it Works */}
      <section className="py-16 px-8 bg-white">
        <h2 className="text-3xl font-bold text-center mb-12">How It Works</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {[
            {
              icon: "🎨",
              title: "1. Create",
              desc: "Set up your event page with a name, date, and theme.",
            },
            {
              icon: "📲",
              title: "2. Share",
              desc: "Send your link or QR code to friends & family.",
            },
            {
              icon: "💌",
              title: "3. Celebrate",
              desc: "Collect messages and photos from guests.",
            },
          ].map((step, i) => (
            <div
              key={i}
              className="bg-pink-50 p-6 rounded-xl shadow text-center"
            >
              <div className="text-4xl mb-2">{step.icon}</div>
              <h3 className="text-xl font-semibold">{step.title}</h3>
              <p className="mt-2 text-gray-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 text-center bg-gradient-to-br from-purple-300 to-pink-200">
        <h2 className="text-4xl font-bold mb-4">
          Ready to make someone’s day extra special?
        </h2>
        <Link
          to="/admin/setup"
          className="mt-6 inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold px-8 py-4 rounded-full text-lg shadow-lg"
        >
          Create an Event
        </Link>
      </section>
    </div>
  );
};

export default HomePage;
